/* Shared by authenticated dashboard tabs. Stores IDs only, no message content. */
export async function claimAlert(key, now = Date.now()) {
    return new Promise(resolve => {
      const request = indexedDB.open('devlive-alert-claims-v1', 1);
      request.onupgradeneeded = () => request.result.createObjectStore('claims').createIndex('at', 'at');
      request.onerror = () => resolve(false);
      request.onsuccess = () => {
        const db = request.result;
        const tx = db.transaction('claims', 'readwrite');
        const store = tx.objectStore('claims');
        let claimed = false;
        const read = store.get(key);
        read.onsuccess = () => {
          if (read.result == null) { store.put({ at: now }, key); claimed = true; }
        };
        // Claims are bounded in age. Session cutoffs independently exclude old pushes.
        let pruned = 0;
        const cursor = store.index('at').openCursor(IDBKeyRange.upperBound(now - 7 * 86400000));
        cursor.onsuccess = () => {
          const row = cursor.result;
          if (!row) return;
          row.delete();
          if (++pruned < 100) row.continue();
        };
        tx.oncomplete = () => { db.close(); resolve(claimed); };
        tx.onerror = tx.onabort = () => { db.close(); resolve(false); };
      };
    });
}
